import { render, staticRenderFns } from "./ChatAnnouncement.vue?vue&type=template&id=0bd6ffaa&scoped=true"
import script from "./ChatAnnouncement.vue?vue&type=script&lang=js"
export * from "./ChatAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./ChatAnnouncement.vue?vue&type=style&index=0&id=0bd6ffaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd6ffaa",
  null
  
)

export default component.exports